/* =========================================================
   Kipor — Chat-Bubble über die Sticky-Leisten heben
   ---------------------------------------------------------
   Problem: Die Shopify-Inbox-Bubble sitzt fest 20px über dem
   unteren Rand. Die Kipor-Sticky-Leisten (PDP-Kaufleiste,
   Warenkorb-Leiste, Mietrechner) sind 72px und mehr hoch —
   die Bubble lag also genau auf dem wichtigsten Button.

   Die frühere Lösung in kipor-theme.css zielte auf
   "#shopify-chat" als ID. Inbox rendert aber ein Custom-
   Element <shopify-chat> mit offenem Shadow-Root; die Regel
   hat deshalb nie gegriffen. Angesprochen wird der Button
   jetzt über ::part(activator) — das CSS steht im Theme.

   Dieses Skript misst, WIE HOCH die gerade aktive Leiste ist,
   und schreibt den Wert nach --kp-sticky-cta-height.

   WICHTIG — warum hier Zustandsflags statt Geometrie gelesen
   werden: Die Leisten blenden sich mit einer Transform-
   Animation ein (~0,3s). getBoundingClientRect() liefert
   während dieser Animation noch die alte Position, die Leiste
   gilt also fälschlich als "nicht da". Die Bubble sprang
   dadurch erst beim nächsten Scroll-Ereignis hoch statt sofort.
   Die Zustandsflags (Klasse bzw. hidden-Attribut) stehen
   dagegen schon fest, bevor die Animation startet — und
   offsetHeight ist von Transforms unabhängig.
   ========================================================= */
(function () {
  'use strict';

  function hasClass(name) {
    return function (el) {
      return el.classList.contains(name);
    };
  }

  function notHidden(el) {
    return !el.hasAttribute('hidden');
  }

  // Die Ergebnisleiste des Mietrechners ist position:sticky ohne
  // Transform — hier ist die Geometrie sofort korrekt und auch die
  // einzige Quelle der Wahrheit, weil sie kein Zustandsflag setzt.
  function stuckToBottom(el) {
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.bottom >= window.innerHeight - 4 && r.top < window.innerHeight;
  }

  // Neue Leisten: entweder hier eintragen oder das Attribut
  // data-kipor-sticky-bar setzen (dann zählt das hidden-Attribut).
  var BARS = [
    { sel: '.kipor-pdp__sticky', active: notHidden },
    { sel: '.kipor-cart__sticky', active: hasClass('is-visible') },
    { sel: '.kpr-sticky', active: hasClass('is-visible') },
    { sel: '.kpr-summary', active: stuckToBottom },
    { sel: '[data-kipor-sticky-bar]', active: notHidden }
  ];

  /* ─────────────────────────────
     Overlays: Bubble ganz ausblenden
     ---------------------------------------------------------
     Bei einem Overlay über dem ganzen Bildschirm (Warenkorb-
     Drawer, Menü, Modal) hilft Verschieben nicht — die Bubble
     landet dann nur auf anderem Inhalt. Im Warenkorb lag sie
     auf "Zur Kasse". Also weg damit, solange das Overlay offen
     ist.

     Das Theme signalisiert offene Overlays nicht einheitlich;
     die bekannten Signale stehen deshalb hier gesammelt statt
     verteilt in der CSS-Datei.
     ───────────────────────────── */
  var OVERLAY_BODY_CLASSES = [
    'kipor-drawer-lock', // Kipor Warenkorb-Drawer
    'overflow-hidden', // Dawn-Modals, Mega-Menü, Quick-View
    'overflow-hidden-mobile' // mobiles Menü
  ];

  var OVERLAY_SELECTORS = [
    '.kipor-drawer.is-open',
    '.kipor-nl-overlay.is-open' // Newsletter-Modal, setzt keine Body-Klasse
  ].join(',');

  function overlayOpen() {
    for (var i = 0; i < OVERLAY_BODY_CLASSES.length; i++) {
      if (document.body.classList.contains(OVERLAY_BODY_CLASSES[i])) return true;
    }
    return !!document.querySelector(OVERLAY_SELECTORS);
  }

  /* ─────────────────────────────
     Stylesheet in den Shadow-Root der Bubble schieben
     ---------------------------------------------------------
     Der Button (part="activator") steckt in einem Wrapper. Wird
     nur der Button per Transform angehoben, bleibt der Wrapper
     an seiner alten Stelle liegen — mit pointer-events: auto.
     Die Bubble sitzt dann optisch oben, schluckt aber weiter die
     Klicks auf den Sticky-CTA darunter. Genau das war der Fehler.

     Der Shadow-Root von <shopify-chat> ist offen, deshalb lässt
     sich dort ein Stylesheet einhängen, das den WRAPPER bewegt.
     Gesteuert wird es über Custom Properties, die sich von :root
     in den Shadow-Root vererben.
     ───────────────────────────── */
  var SHADOW_STYLE_ID = 'kipor-chat-offset-style';
  var SHIFT_CLASS = 'kipor-chat-shift';
  var shadowWatched = false;

  var SHADOW_CSS =
    '.' + SHIFT_CLASS + '{' +
    'transform:translateY(calc(-1 * var(--kp-chat-lift, 0px)))!important;' +
    'opacity:var(--kp-chat-opacity,1);' +
    'visibility:var(--kp-chat-visibility,visible);' +
    'pointer-events:var(--kp-chat-pointer-events,auto);' +
    'transition:transform .25s ease,opacity .18s ease,visibility .18s;}' +
    '@media (prefers-reduced-motion:reduce){.' + SHIFT_CLASS + '{transition:none}}';

  function syncShadow() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return false;

    var sr = host.shadowRoot;

    // Mutationen im Shadow-Root dringen nicht zum Observer im Light-DOM
    // durch. Ohne diesen zweiten Observer würde ein Neuaufbau durch Inbox
    // die Markierung am Wrapper still entfernen.
    if (!shadowWatched && 'MutationObserver' in window) {
      shadowWatched = true;
      new MutationObserver(request).observe(sr, { childList: true, subtree: true });
    }

    var activator = sr.querySelector('[part="activator"]');
    if (!activator) return false;

    // Der Wrapper wird über den Button gefunden, nicht über seinen
    // Klassennamen — der kann sich zwischen Inbox-Versionen ändern.
    var wrapper = activator.parentElement || activator;

    if (!sr.getElementById(SHADOW_STYLE_ID)) {
      var style = document.createElement('style');
      style.id = SHADOW_STYLE_ID;
      style.textContent = SHADOW_CSS;
      sr.appendChild(style);
    }

    // Inbox rendert seinen Inhalt gelegentlich neu; dann ist die
    // Markierung weg und wird hier wieder gesetzt.
    if (!wrapper.classList.contains(SHIFT_CLASS)) {
      wrapper.classList.add(SHIFT_CLASS);
    }

    return true;
  }

  var root = document.documentElement;
  var current = -1;
  var ticking = false;

  function activeBarHeight() {
    var max = 0;

    BARS.forEach(function (bar) {
      [].slice.call(document.querySelectorAll(bar.sel)).forEach(function (el) {
        // offsetHeight ist 0, wenn die Leiste per Media-Query auf
        // display:none steht — der Desktop-Fall erledigt sich damit
        // von selbst.
        var h = el.offsetHeight;
        if (!h) return;
        if (!bar.active(el)) return;
        if (h > max) max = h;
      });
    });

    return Math.round(max);
  }

  function update() {
    ticking = false;

    // Die Bubble wird asynchron nachgeladen, deshalb bei jedem Durchlauf
    // erneut versuchen. kipor-chat-shadow schaltet in kipor-theme.css die
    // Fallback-Regel ab, sobald der Wrapper selbst bewegt wird.
    root.classList.toggle('kipor-chat-shadow', syncShadow());

    // classList.toggle ändert das Attribut nur bei echtem Wechsel —
    // der MutationObserver löst dadurch keine Endlosschleife aus.
    root.classList.toggle('kipor-chat-hidden', overlayOpen());

    var h = activeBarHeight();
    if (h === current) return;
    current = h;
    root.style.setProperty('--kp-sticky-cta-height', h + 'px');
  }

  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request, { passive: true });
  window.addEventListener('load', request);

  // Die Leisten werden per Klasse oder hidden-Attribut umgeschaltet.
  // Der Observer fängt das im selben Moment ab, in dem die Section
  // den Zustand setzt — ohne dass jede Section eine eigene Meldung
  // schicken muss.
  if ('MutationObserver' in window) {
    new MutationObserver(request).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden'],
      // childList, weil Sections sich neu rendern können (z. B. der
      // Warenkorb nach einer Mengenänderung) — dabei wird die Leiste
      // ausgetauscht statt umgeschaltet. Der rAF-Puffer sorgt dafür,
      // dass daraus höchstens eine Messung pro Frame wird.
      childList: true
    });
  }

  // Inbox lädt asynchron und baut seinen Shadow-Inhalt erst danach auf.
  // Beides ist von außen nicht zuverlässig beobachtbar, deshalb wird
  // eine Weile nachgefasst — und aufgehört, sobald es sitzt.
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    request();
    if (root.classList.contains('kipor-chat-shadow') || tries > 40) {
      clearInterval(poll);
    }
  }, 500);

  update();
})();
